export default __webpack_public_path__ + "static/events-light-488a27a11a7f52e00f17dfe296c05613.png";